// extracted by mini-css-extract-plugin
export default {"statusAvatarBackground":"InProgressCommentIndicator-module__statusAvatarBackground--xzHl8","statusAvatar":"InProgressCommentIndicator-module__statusAvatar--BNNHX"};